import { ErrataProvider } from './ErrataProvider';
import { IAuthorityErrata } from './model/authority-tiles/IAuthorityErrata';

// The errata files have a 5 min http cache, so it should be safe to request them every time
// we need them. But we've found that android devices do not reliably use local http cache.
// So this class adds another layer so (a) we don't hit the errata endpoints too frequently
// and (b) we never wait for a response while building advisories. We poll every 1 min, so
// worst case it will be 6 min (5 min for the http cache to bust and 1 min for polling)
// NOTE: This polling logic is currently duplicated in ErrataState in autopylot-app
const POLL_EVERY_MS = 1 * 60 * 1000;

export class CachedErrataProvider {

    private errata: IAuthorityErrata | undefined;

    static inject = () => [ErrataProvider];
    constructor(private errataProvider: ErrataProvider) {
        this.startPolling();
    }

    private startPolling = async () => {
        while (true){
            try {
                this.errata = await this.errataProvider.getErrata();
            }
            catch(err) {
                // ignore, will try again in 2 mins
            }

            await new Promise(resolve => setTimeout(resolve, POLL_EVERY_MS));
        }
    };

    getErrata = async () => {
        if (this.errata) {
            return this.errata;
        } else {
            // just in case this is invoked before we start polling
            return await this.errataProvider.getErrata();
        }
    };
}
